const m = require('minthril');
const { component } = require('../../component');

const Modal = component(() => {
  let element = null;
  let ownerDocument = null;
  let isOpen = false;
  let onClose = null;
  let handleDocumentClick = null;

  return {
    view: ({ attrs, children }) => {
      isOpen = attrs.isOpen;
      onClose = attrs.onClose;

      return m('div', {
        class: `modal${attrs.className ? ` ${attrs.className}` : ''}`,
        oncreate: vnode => {
          element = vnode.dom;
          ownerDocument = element.ownerDocument;
          handleDocumentClick = event => {
            if (isOpen && !element.contains(event.target)) {
              onClose?.(event);
            }
          };
          ownerDocument.addEventListener('click', handleDocumentClick);
        },
        onremove: () => {
          ownerDocument.removeEventListener('click', handleDocumentClick);
          element = null;
          ownerDocument = null;
        }
      }, children);
    }
  };
});

module.exports = { Modal };
